import React from 'react'
import { mountComponents } from '../../mount'

const PaginateBusinessDirectory = React.createClass({
  getInitialState: function () {
    return { appended: false }
  },

  handleClick: function() {
    let $pagination = $('.business-directory-pagination').find('.pagination')
    let $jsLoadMore = $('.js-load-more')

    let paginationUrl = $pagination.find('a[rel=next]').attr('href')
    let url = this.props.url || paginationUrl

    if (url) {
      $.ajax({
        url: url,
        method: 'GET',
        dataType: 'script',
        data: {
          format: 'js',
          sort_filter: false
        },
        beforeSend: function() {
          let $viewMoreBtn = $('.view-more')

          $viewMoreBtn.velocity('fadeOut', 10)
          $jsLoadMore.slideDownThenFadeIn(100)
        },
        success: function(response) {
          this.setState({appended: true })
          $jsLoadMore.fadeOutThenSlideUp(10);
          mountComponents()
        }.bind(this)
      })
    }
  },

  render: function() {
    return(
      <div className='row'>
        <div className='col-md-4 col-md-offset-4 mb20'>
          <button className='btn btn-clear btn-block btn-lg view-more radius-6' onClick={this.handleClick}>View More</button>
          <div className='js-load-more mt40 text-center velocity-hidden'>
            <div className='spinner-icon'></div>
            <div className='span loading-text ml10 fs18'>
              Loading businesses...
            </div>
          </div>
        </div>
      </div>
    )
  }
})

export default PaginateBusinessDirectory
